module.exports = __webpack_public_path__ + "static/contact-c26b485f1b971671d9461ec0e4863341.jpg";